import { IconButton, Stack, Badge, Popover, Box, TextField, MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useState } from "react";


export default function EstadoEstabelecimentoFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openSelect, setOpenSelect] = useState(true);
   
  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
          setOpenSelect(!openSelect);
        }}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.filtro}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>
          <TextField
            style={{ width: 200 }}
            type="text"
            placeholder="Estado"
            label='Estado'
            select
            size="small"
            variant="outlined"
            onChange={(e) => { props.setFiltro(e.target.value === 'Geral' ? '' : e.target.value) }}
            value={props.filtro}
            SelectProps={{
              open: openSelect,
              onOpen: () => setOpenSelect(true),
              onClose: () => setOpenSelect(false),
            }}
          >
            <MenuItem value={''}>Geral</MenuItem>
            <MenuItem value='Activo'>Activo</MenuItem>
            <MenuItem value='Reprovado'>Reprovado</MenuItem>
            <MenuItem value='Inspecção Agendada'>Inspecção Agendada</MenuItem>
            <MenuItem value='Análise'>Análise</MenuItem>
            <MenuItem value='Analisado'>Analisado</MenuItem>
            <MenuItem value='Analisado Chefe de Secção'>Analisado Chefe de Secção</MenuItem>
            <MenuItem value='Inspecção Realizada'>Inspecção Realizada</MenuItem>
            <MenuItem value='Deferimento'>Deferimento</MenuItem>
            <MenuItem value='Inactivo'>Inactivo</MenuItem>
            <MenuItem value='Por Renovar'>Por Renovar</MenuItem>
            <MenuItem value='Não Licenciado'>Não Licenciado</MenuItem>
          </TextField>
        </Box>
      </Popover>
    </Stack>
  );
};


